<ng-container *ngIf="filteredArchives.length > 0; else noArchives">
    <ng-container *ngFor="let section of patientStatusOptions">
        <div class="list-header expandable" (click)="toggleExpanded(section.id)">
            {{ section.name }}
            <mat-icon aria-hidden="false" aria-label="Expand/Collapse">
                {{ expandedSection === section.id ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <div *ngIf="expandedSection === section.id">
            <mat-list>
                <mat-list-item *ngFor="let archive of $any(section.archives | slice:0:shown)" class="auto-height">
                    <div class="list-item stack-mobile">
                        <div class="details">
                            <div matLine class="primary-text">
                                <b>{{ archive.surname }}, {{ archive.name }}</b>
                            </div>
                            <div matLine class="secondary-text">
                                <span>{{ archive.diagnosis || archive.email || '' }}</span>
                            </div>
                        </div>
                        <div class="action-icons">
                            <button mat-icon-button matTooltip="Restore this patient file"
                                (click)="restorePatientFile($event, archive.id)">
                                <mat-icon>restore</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="View the patient file"
                                (click)="navigateToPatientFile($event, archive.id)">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-list-item>
                <div *ngIf="shown < section.archives.length" (appRenderMore)="shown = shown + renderBatch"></div>
            </mat-list>
        </div>
    </ng-container>
</ng-container>
<div class="mobile-spacer"></div>

<ng-template #noArchives>
    <p class="no-records-message">No archived patients found.</p>
</ng-template>